import css from "../../assets/css/Mywallet.module.css";
import { Link } from "react-router-dom";
import { AiOutlinePlus } from "react-icons/ai";
import { BsWallet2 } from "react-icons/bs";
import { RiHistoryLine, RiGiftLine } from "react-icons/ri";

const Mywallet = ({ user }) => {
  const depositAmount = user
    ? Math.max(0, (user?.Wallet_balance || 0) - (user?.withdrawAmount || 0))
    : 0;

  return (
    <>
      <div className="leftContainer page_layout">
        <div className="page_content">
          {/* Total Balance Hero Card */}
          <div className={css.totalBalanceHero}>
          <span className={css.heroLabel}>Total Balance</span>
          <h1 className={css.heroAmount}>₹{user ? user?.Wallet_balance : 0}</h1>
          <p className={css.heroSubtitle}>
            Instant withdrawals &amp; deposit available 24x7
          </p>
        </div>

        {/* Deposit & Winning Cash Cards */}
        <div className={css.cardsGrid}>
          <div className={css.cardItem}>
            <div className={css.cardHeader}>
              <div className={css.cardLeft}>
                <div className={`${css.cardIconWrap} ${css.depositIcon}`}>
                  <img src="/images/icons/depositt.png" alt="Deposit" />
                </div>
                <div className={css.cardMeta}>
                  <span className={css.cardTitle}>Deposit Cash</span>
                  <h2 className={css.cardValue}>₹{depositAmount}</h2>
                </div>
              </div>
            </div>
            <Link to="/addcase" style={{ textDecoration: "none" }}>
              <button className={css.btnActionDeposit}>
                <AiOutlinePlus />
                <span>Add Cash</span>
              </button>
            </Link>
          </div>

          <div className={css.cardItem}>
            <div className={css.cardHeader}>
              <div className={css.cardLeft}>
                <div className={`${css.cardIconWrap} ${css.winningIcon}`}>
                  <img src="/images/icons/win-cash.png" alt="Winning" />
                </div>
                <div className={css.cardMeta}>
                  <span className={css.cardTitle}>Winning Cash</span>
                  <h2 className={css.cardValue}>
                    ₹{user ? user?.withdrawAmount : 0}
                  </h2>
                </div>
              </div>
            </div>
            <Link to="/Withdraw" style={{ textDecoration: "none" }}>
              <button className={css.btnActionWithdraw}>
                <BsWallet2 />
                <span>Withdraw</span>
              </button>
            </Link>
          </div>
        </div>

        {/* Quick Wallet Links */}
        <div className={css.quickNavGroup}>
          <Link to="/history" className={css.quickNavItem}>
            <div className={css.quickNavLeft}>
              <div className={css.quickNavIcon}>
                <RiHistoryLine />
              </div>
              <span className={css.quickNavText}>Transaction History</span>
            </div>
            <img
              src="/images/icons/right-arrow.png"
              alt=">"
              className={css.quickNavArrow}
            />
          </Link>

          <Link to="/refer" className={css.quickNavItem}>
            <div className={css.quickNavLeft}>
              <div className={css.quickNavIcon}>
                <RiGiftLine />
              </div>
              <span className={css.quickNavText}>Referral Rewards</span>
            </div>
            <img
              src="/images/icons/right-arrow.png"
              alt=">"
              className={css.quickNavArrow}
            />
          </Link>
        </div>
        </div>
      </div>
    </>
  );
};

export default Mywallet;
